import {AppModel} from "@/models/app-model";

const ChangeSelected = (listItemId, listItems) => {

  const appModel = new AppModel();

  const items = listItems.map((item) => {
    if (item.id === listItemId) {
      item.is_selected = !item.is_selected;
      appModel.setLat(item.lat);
      appModel.setLng(item.lng);
    } else {
      item.is_selected = false;
    }
    return item;
  });

  appModel.setListItems(items);

  return appModel;
}

export {ChangeSelected};